"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mail-in-a-Box
 * Mail-in-a-Box API HTTP specification.
 *
 * The version of the OpenAPI document: 0.47.0
 * Contact: contact@mailinabox.email
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNSApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var DNSApi = /** @class */ (function (_super) {
    __extends(DNSApi, _super);
    function DNSApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds a custom DNS A record for the specified query name.
     * Add DNS custom A record
     */
    DNSApi.prototype.addDnsCustomARecordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling addDnsCustomARecord.');
                        }
                        if (requestParameters.body === null ||
                            requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling addDnsCustomARecord.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}".replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Adds a custom DNS A record for the specified query name.
     * Add DNS custom A record
     */
    DNSApi.prototype.addDnsCustomARecord = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addDnsCustomARecordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds a custom DNS record for the specified query name and type.
     * Add DNS custom record
     */
    DNSApi.prototype.addDnsCustomRecordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling addDnsCustomRecord.');
                        }
                        if (requestParameters.rtype === null ||
                            requestParameters.rtype === undefined) {
                            throw new runtime.RequiredError('rtype', 'Required parameter requestParameters.rtype was null or undefined when calling addDnsCustomRecord.');
                        }
                        if (requestParameters.body === null ||
                            requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling addDnsCustomRecord.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}/{rtype}"
                                    .replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname)))
                                    .replace("{" + 'rtype' + "}", encodeURIComponent(String(requestParameters.rtype))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Adds a custom DNS record for the specified query name and type.
     * Add DNS custom record
     */
    DNSApi.prototype.addDnsCustomRecord = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addDnsCustomRecordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds one or more secondary nameservers.
     * Add DNS secondary nameserver
     */
    DNSApi.prototype.addDnsSecondaryNameserverRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.hostnames === null ||
                            requestParameters.hostnames === undefined) {
                            throw new runtime.RequiredError('hostnames', 'Required parameter requestParameters.hostnames was null or undefined when calling addDnsSecondaryNameserver.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.hostnames !== undefined) {
                            formParams.append('hostnames', requestParameters.hostnames);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/secondary-nameserver",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Adds one or more secondary nameservers.
     * Add DNS secondary nameserver
     */
    DNSApi.prototype.addDnsSecondaryNameserver = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addDnsSecondaryNameserverRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all custom A records for the specified query name.
     * Get DNS custom A records
     */
    DNSApi.prototype.getDnsCustomARecordsForQNameRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling getDnsCustomARecordsForQName.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}".replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.DNSCustomRecordsResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns all custom A records for the specified query name.
     * Get DNS custom A records
     */
    DNSApi.prototype.getDnsCustomARecordsForQName = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDnsCustomARecordsForQNameRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all custom DNS records.
     * Get DNS custom records
     */
    DNSApi.prototype.getDnsCustomRecordsRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.DNSCustomRecordsResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns all custom DNS records.
     * Get DNS custom records
     */
    DNSApi.prototype.getDnsCustomRecords = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDnsCustomRecordsRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all custom records for the specified query name and type.
     * Get DNS custom records
     */
    DNSApi.prototype.getDnsCustomRecordsForQNameAndTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling getDnsCustomRecordsForQNameAndType.');
                        }
                        if (requestParameters.rtype === null ||
                            requestParameters.rtype === undefined) {
                            throw new runtime.RequiredError('rtype', 'Required parameter requestParameters.rtype was null or undefined when calling getDnsCustomRecordsForQNameAndType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}/{rtype}"
                                    .replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname)))
                                    .replace("{" + 'rtype' + "}", encodeURIComponent(String(requestParameters.rtype))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.DNSCustomRecordsResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns all custom records for the specified query name and type.
     * Get DNS custom records
     */
    DNSApi.prototype.getDnsCustomRecordsForQNameAndType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDnsCustomRecordsForQNameAndTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all DNS records.
     * Get DNS dump
     */
    DNSApi.prototype.getDnsDumpRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/dump",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.DNSDumpResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns all DNS records.
     * Get DNS dump
     */
    DNSApi.prototype.getDnsDump = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDnsDumpRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list of nameserver hostnames.
     * Get DNS secondary nameserver
     */
    DNSApi.prototype.getDnsSecondaryNameserverRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/secondary-nameserver",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.DNSSecondaryNameserverResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns a list of nameserver hostnames.
     * Get DNS secondary nameserver
     */
    DNSApi.prototype.getDnsSecondaryNameserver = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDnsSecondaryNameserverRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns an array of all managed top-level domains.
     * Get DNS zones
     */
    DNSApi.prototype.getDnsZonesRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/zones",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.DNSZonesResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns an array of all managed top-level domains.
     * Get DNS zones
     */
    DNSApi.prototype.getDnsZones = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDnsZonesRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Removes a DNS custom A record for the specified domain & value.
     * Remove DNS custom A record
     */
    DNSApi.prototype.removeDnsCustomARecordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling removeDnsCustomARecord.');
                        }
                        if (requestParameters.body === null ||
                            requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling removeDnsCustomARecord.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}".replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Removes a DNS custom A record for the specified domain & value.
     * Remove DNS custom A record
     */
    DNSApi.prototype.removeDnsCustomARecord = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeDnsCustomARecordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Removes a DNS custom record for the specified domain, type & value.
     * Remove DNS custom record
     */
    DNSApi.prototype.removeDnsCustomRecordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling removeDnsCustomRecord.');
                        }
                        if (requestParameters.rtype === null ||
                            requestParameters.rtype === undefined) {
                            throw new runtime.RequiredError('rtype', 'Required parameter requestParameters.rtype was null or undefined when calling removeDnsCustomRecord.');
                        }
                        if (requestParameters.body === null ||
                            requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling removeDnsCustomRecord.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}/{rtype}"
                                    .replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname)))
                                    .replace("{" + 'rtype' + "}", encodeURIComponent(String(requestParameters.rtype))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Removes a DNS custom record for the specified domain, type & value.
     * Remove DNS custom record
     */
    DNSApi.prototype.removeDnsCustomRecord = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeDnsCustomRecordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the DNS. Involves creating zone files and restarting `nsd`.
     * Update DNS
     */
    DNSApi.prototype.updateDnsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.force === null ||
                            requestParameters.force === undefined) {
                            throw new runtime.RequiredError('force', 'Required parameter requestParameters.force was null or undefined when calling updateDns.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.force !== undefined) {
                            formParams.append('force', requestParameters.force);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/update",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Updates the DNS. Involves creating zone files and restarting `nsd`.
     * Update DNS
     */
    DNSApi.prototype.updateDns = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDnsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an existing DNS custom A record value for the specified qname.
     * Update DNS custom A record
     */
    DNSApi.prototype.updateDnsCustomARecordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling updateDnsCustomARecord.');
                        }
                        if (requestParameters.body === null ||
                            requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateDnsCustomARecord.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}".replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Updates an existing DNS custom A record value for the specified qname.
     * Update DNS custom A record
     */
    DNSApi.prototype.updateDnsCustomARecord = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDnsCustomARecordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an existing DNS custom record value for the specified qname and type.
     * Update DNS custom record
     */
    DNSApi.prototype.updateDnsCustomRecordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.qname === null ||
                            requestParameters.qname === undefined) {
                            throw new runtime.RequiredError('qname', 'Required parameter requestParameters.qname was null or undefined when calling updateDnsCustomRecord.');
                        }
                        if (requestParameters.rtype === null ||
                            requestParameters.rtype === undefined) {
                            throw new runtime.RequiredError('rtype', 'Required parameter requestParameters.rtype was null or undefined when calling updateDnsCustomRecord.');
                        }
                        if (requestParameters.body === null ||
                            requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateDnsCustomRecord.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/dns/custom/{qname}/{rtype}"
                                    .replace("{" + 'qname' + "}", encodeURIComponent(String(requestParameters.qname)))
                                    .replace("{" + 'rtype' + "}", encodeURIComponent(String(requestParameters.rtype))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Updates an existing DNS custom record value for the specified qname and type.
     * Update DNS custom record
     */
    DNSApi.prototype.updateDnsCustomRecord = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDnsCustomRecordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DNSApi;
}(runtime.BaseAPI));
exports.DNSApi = DNSApi;
